'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const getDocument = (node) => {
  if (node.nodeType === Node.DOCUMENT_NODE)
    return node;
  return node.ownerDocument ?? document;
};
function createScope(methods) {
  const screen = {
    getRootNode: (ctx) => ctx.getRootNode?.() ?? document,
    getDoc: (ctx) => getDocument(screen.getRootNode(ctx)),
    getWin: (ctx) => screen.getDoc(ctx).defaultView ?? window,
    getActiveElement: (ctx) => screen.getDoc(ctx).activeElement,
    getById: (ctx, id) => screen.getRootNode(ctx).getElementById(id),
    queryById: (ctx, id) => {
      const el = screen.getById(ctx, id);
      if (!el)
        throw new Error(`Element with id "${id}" not found.`);
      return el;
    }
  };
  return { ...screen, ...methods };
}

exports.createScope = createScope;
